module.exports = __webpack_public_path__ + "img/olausfastigheter.31f9f136.png";